import React from 'react';
import PropTypes from 'prop-types';
import RegisterForm from '../../components/RegisterForm';

class Register extends React.Component {
  render() {
    return <RegisterForm />;
  }
}

Register.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Register;



// WEBPACK FOOTER //
// ./src/routes/register/Register.js